import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useRef, useCallback, } from 'react';
import BezierEasing from 'bezier-easing';
import { useTransition, animated } from '@react-spring/web';
import { DEFAULT_LARGE_TRANSITION_DURATION_MS } from '../../../constants/statics';
import RankItemWrapper from './rankItemWrapper';
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const NEW_ITEM_DEFAULT_HEIGHT = 100;
const RankList = ({ className, elmId = '', itemData, transitionDurationMs = DEFAULT_LARGE_TRANSITION_DURATION_MS, }) => {
    const refs = useRef([]);
    const [rankItems, setRankItems] = useState([]);
    const [trigger, setTrigger] = useState(0);
    const getRankItemHeight = useCallback((elm) => {
        if (!elm)
            return NEW_ITEM_DEFAULT_HEIGHT;
        const style = window.getComputedStyle(elm);
        const margin = (parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0);
        return Math.ceil(elm.offsetHeight + margin);
    }, []);
    useEffect(() => {
        let contentChanged = false;
        const newItems = itemData.map(item => {
            const existingRankItem = rankItems.find(i => i.id === item.props.id);
            if (existingRankItem) {
                if (existingRankItem.content !== item) {
                    contentChanged = true;
                    return { ...existingRankItem, content: item };
                }
                return { ...existingRankItem };
            }
            else {
                const newRef = { current: null };
                refs.current.push(newRef);
                return { id: item.props.id, ref: newRef, content: item };
            }
        });
        if (contentChanged) {
            setTimeout(() => {
                setTrigger(prev => prev + 1);
            }, 1);
            setTimeout(() => {
                setTrigger(prev => prev + 1);
            }, transitionDurationMs);
        }
        setRankItems(prev => {
            if (prev.length !== newItems.length) {
                setTrigger(prev => prev + 1);
            }
            return newItems;
        });
    }, [itemData, trigger]);
    useEffect(() => {
        setTrigger(prev => prev + 1);
    }, [refs]);
    let height = 0;
    const transitions = useTransition(rankItems.map(item => {
        const itemHeight = getRankItemHeight(item.ref.current);
        return {
            ...item,
            height: itemHeight,
            y: (height += itemHeight) - itemHeight,
        };
    }), {
        key: (item) => item.id,
        from: { height: 0, opacity: 0 },
        leave: { height: 0, opacity: 0 },
        enter: ({ y, height }) => ({ y, height, opacity: 1 }),
        update: ({ y, height }) => ({ y, height }),
        config: {
            duration: transitionDurationMs,
            easing: BezierEasing(0.5, -0.1, 0.5, 1.2),
        },
    });
    return (_jsx("div", { className: cx('list', className), "data-elm-id": elmId, style: { height }, children: transitions((style, item, _t, index) => (_jsx(animated.div, { className: cx('animated-item'), style: { zIndex: rankItems.length - index, ...style }, children: _jsx(RankItemWrapper, { id: item.id, ref: item.ref, children: item.content }) }, item.id))) }));
};
export default RankList;
//# sourceMappingURL=index.js.map